// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4319":"3a4510d11907e2e3","5297":"d5feb23a95b51093"}[chunkId] + ".css";
};